import logError from './errorLogger'

interface DocumentViewerOptions {
  url: string
  filename: string
  fallbackToDirectOpen?: boolean
}

export const openDocumentViewer = ({
  url,
  filename,
  fallbackToDirectOpen = true
}: DocumentViewerOptions): void => {
  try {
    const fileExtension = filename.toLowerCase().split('.').pop() || ''

    if (
      ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(
        fileExtension
      )
    ) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }

    if (['txt', 'csv'].includes(fileExtension)) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }

    if (fileExtension === 'pdf') {
      if (fallbackToDirectOpen) {
        window.open(url, '_blank', 'noopener,noreferrer')
        return
      } else {
        const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
          url
        )}&embedded=true`
        window.open(viewerUrl, '_blank', 'noopener,noreferrer')
        return
      }
    }

    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
      url
    )}&embedded=true`
    window.open(viewerUrl, '_blank', 'noopener,noreferrer')
  } catch (error) {
    logError('Erro ao abrir documento', error as Error)

    if (fallbackToDirectOpen) {
      try {
        window.open(url, '_blank', 'noopener,noreferrer')
      } catch (fallbackError) {
        logError(
          'Erro no fallback de abertura de documento',
          fallbackError as Error
        )
      }
    }
  }
}

export const openPdfDocument = (url: string, filename: string): void => {
  openDocumentViewer({
    url,
    filename,
    fallbackToDirectOpen: true
  })
}

export const openDocumentWithViewer = (url: string, filename: string): void => {
  openDocumentViewer({
    url,
    filename,
    fallbackToDirectOpen: false
  })
}

export default openDocumentViewer
